module.exports = ".bolt-panel-footer-buttons {\r\n    flex-wrap: wrap;\r\n}"